/**
 * #39 · Módulo de lotes. Contrato en `routes/module.ts`.
 *
 * Sin `minimumRole`: `GET /api/v1/batches` es de `viewer`. Crear y editar
 * exigen `analyst`, y **retirar exige `admin`** — los tres botones se
 * esconden según el rol, pero la lista la ve cualquiera con sesión.
 */
import type { ModuleRoutes } from '../module';
import { BatchDetailPage } from './BatchDetailPage';
import { BatchesPage } from './BatchesPage';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'batches',
  routes: [
    { path: '', element: <BatchesPage /> },
    { path: ':batchId', element: <BatchDetailPage /> },
  ],
};
